import type { ICalendarItemDTO } from "../../../../../../api";

export enum BulkBaseIndexControlDateRange {
  Annual = 1,
  Quarter = 3,
  Month = 4,
  Week = 7,
}

export interface IBulkBaseIndexControlState<T extends number | string | unknown = unknown> {
  lastCalendar: Partial<Record<BulkBaseIndexControlDateRange, T>>;
  items: Record<BulkBaseIndexControlDateRange, ICalendarItemDTO<T>[]>;
  value: Partial<Record<BulkBaseIndexControlDateRange, T>>;
  selectedRanges: BulkBaseIndexControlDateRange[];
  availableDateRanges: BulkBaseIndexControlDateRange[];
  selection: (string | number)[];
}

export interface IBulkBaseIndexControlAction {
  type: string;
  payload: {
    dateRange?: BulkBaseIndexControlDateRange;
    value: unknown;
  };
}

export interface IBulkBaseIndexControlProps {
  dataSourceId: number;
  onChange?: (selection: (string | number)[]) => void;
  selection: (string | number)[];
  items: ICalendarItemDTO<string | number>[];
  availableDateRanges: BulkBaseIndexControlDateRange[];
  isBulkSubscribtion: boolean;
}
